export default "<app-detail [title] = \"title\" [cardType] = \"cardType\" [buttonType] = \"buttonType\" [cards] = \"categories\" ></app-detail>\n"